<template>
  <v-app id="buscaCentro">
    <v-content>
      <v-container grid-list-lg fluid>
        <v-layout row wrap>
          <v-flex xs12 class="py-0">
            <h4 class="grey--text text--darken-1">
              <v-icon small color="primary">drag_indicator</v-icon> Cursos de Capacitación
            </h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md9>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="cursos"
                :search="search"
                :rows-per-page-items="rowsPerPage"
                rows-per-page-text="Filas por página"
                no-results-text="Sin resultados"
                no-data-text="Sin registros"
                class="elevation-1"
              >
                <!-- :pagination.sync="pagination" -->
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>{{ props.item.area_formacion }}</td>
                  <td>{{ props.item.codigo }}</td>
                  <td>{{ props.item.nombre }}</td>
                </template>
              </v-data-table>
              <!-- <div class="text-xs-center pt-2">
                <v-pagination total-visible="6" color="primary" v-model="pagination.page" :length="pages"></v-pagination>
              </div> -->
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-card>
              <v-card-title>
                <h5 class="grey--text text--darken-1">Área</h5>
                <v-spacer></v-spacer>
                <h5 class="grey--text text--darken-1">Cantidad Cursos</h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list dense tile>
                  <v-list-tile
                    v-for="item in areas"
                    :key="item.id"
                  >
                    <v-list-tile-content>
                      <!-- <v-list-tile-title v-text="item.area"></v-list-tile-title> -->
                      <v-list-tile-sub-title v-text="item.area_formacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                    <v-list-tile-action-text>{{ item.cantidad }}</v-list-tile-action-text>
                  </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <small><b>TOTAL {{ totalCursos }}</b> Cursos Autorizados con R.M.</small>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
      <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: 'curso-informacion',
  data: () => ({
    search: '',
    // pagination: {
    //   totalItems: 0,
    //   rowsPerPage: 1
    // },
    rowsPerPage: [10, 20, 30, 50, 100, {'text': 'Todos', value: -1}],
    selected: [],
    loading: false,
    headers: [
      { text: 'Nro', align: 'left', sortable: false, },
      { text: 'Ára ', value: 'area_formacion' },
      { text: 'Código ', value: 'codigo' },
      { text: 'Denominación del Curso ', value: 'nombre' }
    ],
    areas: [],
    cursos: [],
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    },
    message: ""
  }),
  mounted() {
    this.getAreaCursos();
  },
  computed :{
    totalCursos: function(){
      let total = 0;
      this.areas.forEach(function(item) {
         total += parseFloat(item.cantidad);
      });
      return total;
    }
  },
  methods: {
    getAreaCursos() {
      axios.get(Service.getServe() + 'out/area/cursos').then(response => {
        this.areas = response.data.areas;
        this.cursos = response.data.cursos;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>